import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import speciesName from '../utils/speciesName';
import { DESCRIPTIONS_TAG_ID, DESCRIPTIONS_PARENT_TAG_ID } from '../utils/descriptionsTag';
const COUNT = 5;
/**
 * Homepage sidebar widget, below "Nouvelle discussion" (see
 * addHomeDescriptions.js) - random sample of "descriptions"-tagged
 * discussions, matching champis.net/home's own "Descriptions" box: species
 * name (+ French vernacular name when GBIF/TAXREF has one), a photo, and
 * the author, each linking to /description/:id.
 */
export default class RandomDescriptions extends Component {
  items = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.items = null;
    this.load();
  }
  load() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/random-descriptions',
      params: {
        filter: {
          limit: COUNT
        }
      }
    }).then(response => {
      this.items = (response.data || []).map(item => ({
        id: item.id,
        ...item.attributes
      }));
      m.redraw();
    }).catch(() => {
      this.items = [];
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "ChampisRandomDescriptions"
    }, m("h2", {
      className: "ChampisSpeciesSearch-label"
    }, m("span", null, m("i", {
      className: "icon fas fa-image",
      "aria-hidden": "true"
    }), " ", app.translator.trans('champis-species.forum.random_descriptions.title')), this.newDescriptionButton()), this.items === null ? m(LoadingIndicator, {
      display: "block"
    }) : this.items.length > 0 && this.list());
  }

  // Same disabled/login-fallback logic as champis-events' UpcomingEvents.tsx
  // own newEventButton() - see that one's docblock for why it's a plain
  // copy of DescriptionsPage.js's newDiscussionButton() rather than reusing
  // IndexSidebar's own newDiscussionAction(), plus the tag pre-selection.
  newDescriptionButton() {
    const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user;
    return m(Button, {
      icon: "fas fa-plus",
      className: "Button Button--icon Button--flat ChampisRandomDescriptions-addButton",
      "aria-label": app.translator.trans('champis-species.forum.random_descriptions.new_description_button'),
      onclick: () => this.newDescriptionAction(),
      disabled: !canStartDiscussion
    });
  }
  newDescriptionAction() {
    if (!app.session.user) {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
      return;
    }

    // Same as champis-events' UpcomingEvents.tsx newEventAction(): the tags
    // set before the composer shows, or it opens the category picker.
    const tag = id => app.store.getById('tags', String(id)) ?? app.store.find('tags', String(id));
    Promise.all([tag(DESCRIPTIONS_PARENT_TAG_ID), tag(DESCRIPTIONS_TAG_ID)]).then(_ref => {
      let [parentTag, descriptionsTag] = _ref;
      return app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
        user: app.session.user
      }).then(loaded => {
        // Not over a draft its author chose to keep (see champis-forum's
        // startDiscussion()).
        if (!loaded) return;
        app.composer.fields.tags = [parentTag, descriptionsTag];
        app.composer.show();
      });
    });
  }
  list() {
    return m("ul", null, (this.items || []).map(item => m("li", {
      key: item.discussionId
    }, m(Link, {
      href: app.route.description(item.discussionId, item.canonicalName),
      className: "ChampisRandomDescriptions-item"
    }, m("span", {
      className: "ChampisRandomDescriptions-text"
    }, m("span", {
      className: "ChampisRandomDescriptions-name"
    }, speciesName(item), item.synonymCanonicalName && m("small", null, ' ', "(=", ' ', speciesName({
      canonicalName: item.synonymCanonicalName,
      author: item.synonymAuthor,
      scientificName: item.synonymCanonicalName
    }), ")")), item.vernacularName && m("span", {
      className: "ChampisRandomDescriptions-vernacular"
    }, item.vernacularName), m("span", {
      className: "ChampisRandomDescriptions-author"
    }, app.translator.trans('champis-species.forum.random_descriptions.by', {
      username: item.authorName
    }))), item.imageUrl && m("img", {
      src: item.imageUrl,
      alt: "",
      loading: "lazy"
    })))));
  }
}
flarum.reg.add('champis-species', 'forum/components/RandomDescriptions', RandomDescriptions);